


















import Vue from "vue";
import { mapActions, mapMutations } from "vuex";
import { ADD_ALERT } from "@/store/modules/AlertModule/mutations";
import { FETCH_UPDATE_PACKAGES_LIST } from "@/store/modules/UpdatePackagesModule/actions";

import { AlertModel, AlertModelType } from "@/store/modules/AlertModule/types";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { RemoveUpdatePackageCommand } from "@/model/communication/updatePackages/RemoveUpdatePackageCommand";

export default Vue.extend({
    data() {
        return {
            deleteLoading: false,
        };
    },
    props: {
        updatePackage: {},
    },
    methods: {
        ...mapActions([FETCH_UPDATE_PACKAGES_LIST]),
        ...mapMutations([ADD_ALERT]),

        stringConverter(string: string) {
            return string.replace(/\./g, "^");
        },

        async deleteItem() {
            this.deleteLoading = true;

            var fileNameTemp = this.stringConverter(this.updatePackage.fileName);
            let response: ApiGenericResponse = await new RemoveUpdatePackageCommand(fileNameTemp).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString == "Success") this[FETCH_UPDATE_PACKAGES_LIST]();
            else this[ADD_ALERT](new AlertModel(AlertModelType.Error, this.$t("update_packages.delete_package_error"), null));

            this.deleteLoading = false;
            this.$emit("close");
        },
    },
});
